{
	"title": "Атрибути на уловения въглерод",
	"buttonTitle": "Улавяне и съхранение на въглерод",
	"table": {
		"materialDescription": "Материал",
		"quantity": "Количество",
		"productGwpTotal": "Общо GWP на продукта",
		"bundledCarbonReductions": "Пакетирани въглеродни редукции",
		"remainingGwp": "Оставащ GWP",
		"epdForPhysicalMaterial": "EPD за физически материал",
		"carbonPlantName": "Бревик, Норвегия"
	},
	"declarationDetailsBanner": {
		"rightfulHolderText": "е законният притежател на отчетените въглеродни редукции."
	},
	"modal": {
		"title": "Улавяне и съхранение на въглерод",
		"description": "Улавянето и съхранението на въглерод (CCS) е технология, която може да улавя емисиите на въглероден диоксид (CO2), произведени от процеса на калциниране и от използването на горива при работа на пещта, като предотвратява навлизането на въглеродния диоксид в атмосферата и го съхранява трайно под земята. Уловеният CO2 от завода на Heidelberg Materials в Бревик, Норвегия, се компресира и транспортира до място за съхранение под Северно море. Съоръжението в нашия завод в Бревик ще улавя 400 000 тона CO2 годишно.",
		"showLink": "Научете повече за процеса на улавяне на въглерод",
		"buttonClose": "Затвори"
	},
	"footnote": "1) Въглеродните редукции компенсират етапи A1-A3 от инвентаризацията на жизнения цикъл на цимента."
}
